import { CitationBadge } from 'components/ui/CitationBadge'
import { CitationSource } from 'types/chat-message'
import { useOpenSource } from 'components/notebook/DocumentPreviewContext'

type SourceCitationProps = {
  num: string
  source: CitationSource
}

/** Inline citation for a remote source ([N]): a clickable badge, or a neutral one when it has no url. */
export const SourceCitation = ({ num, source }: SourceCitationProps) => {
  // Le sorgenti `site` puntano a un sito esterno, non a un upload: si aprono direttamente.
  const isSite = source.type === 'site'
  const openSource = useOpenSource()

  const href = isSite
    ? (source.pageUrl ?? source.url ?? '')
    : (source.url ?? '') + (source.page != null ? `#page=${source.page}` : '')

  const title = source.name + (source.page != null ? ` (p. ${source.page})` : '')

  if (href) {
    return (
      <CitationBadge
        label={num}
        href={href}
        // ! L'url memorizzato è nudo e da solo vale 403: si scambia con uno firmato al click.
        onActivate={
          isSite ? undefined : () => void openSource(source, source.page != null ? `#page=${source.page}` : '')
        }
        title={title}
        className="align-super mx-px"
      />
    )
  }

  return <CitationBadge label={num} variant="neutral" title={source.name} className="align-super mx-px" />
}
